module.exports = __webpack_public_path__ + "static/media/U1-T2-4-4.101e7ef2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-4-4.svg
// module id = 592
// module chunks = 0